import React, { useState } from 'react';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export const QuizRunner = ({ questions, onSubmit, submitLabel = 'Submit', result, testidPrefix = 'mm-quiz' }) => {
  const [answers, setAnswers] = useState({});
  const [busy, setBusy] = useState(false);
  const byId = Object.fromEntries((result?.results || []).map((r) => [r.id, r]));

  const submit = async () => {
    setBusy(true);
    try { await onSubmit(answers); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid={testidPrefix}>
      {questions.map((q, i) => {
        const r = byId[q.id];
        return (
          <div key={q.id} className={`border-2 p-4 ${r ? (r.correct ? 'border-emerald-500/50' : 'border-red-500/40') : 'border-zinc-800'}`} data-testid={`${testidPrefix}-q-${q.id}`}>
            <div className="flex gap-2 text-sm text-white font-medium"><span className="text-emerald-400 font-black">{i + 1}.</span><span>{q.prompt}</span></div>
            {q.type === 'mc' ? (
              <div className="grid sm:grid-cols-2 gap-2 mt-3">
                {q.options.map((o) => {
                  const letter = o.trim()[0];
                  const sel = (answers[q.id] || r?.given) === letter;
                  return (
                    <button key={o} type="button" disabled={!!result} onClick={() => setAnswers({ ...answers, [q.id]: letter })} className={`text-left text-xs px-3 py-2 border-2 transition-colors ${sel ? 'border-emerald-500 bg-emerald-500/10 text-white' : 'border-zinc-800 text-zinc-300 hover:border-zinc-600'}`} data-testid={`${testidPrefix}-opt-${q.id}-${letter}`}>{o}</button>
                  );
                })}
              </div>
            ) : (
              <input disabled={!!result} value={answers[q.id] ?? r?.given ?? ''} onChange={(e) => setAnswers({ ...answers, [q.id]: e.target.value })} className="mt-3 w-full sm:w-72 bg-black border-2 border-zinc-800 focus:border-emerald-500 outline-none px-3 py-2 text-sm text-white" placeholder="Your answer" data-testid={`${testidPrefix}-input-${q.id}`} />
            )}
            {r && (
              <div className="mt-3 text-xs flex gap-2">
                {r.correct ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" /> : <XCircle className="w-4 h-4 text-red-400 shrink-0" />}
                <span className="text-zinc-300">{!r.correct && <>Answer: <b className="text-white">{r.answer}</b>. </>}{r.explanation}</span>
              </div>
            )}
          </div>
        );
      })}
      {!result && (
        <button onClick={submit} disabled={busy} className="flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-black px-6 py-3 text-[11px] font-black uppercase tracking-widest disabled:opacity-50" data-testid={`${testidPrefix}-submit`}>
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} {submitLabel}
        </button>
      )}
    </div>
  );
};
